import React, { Component } from "react";
import "./Privacy.css";
import Header from "../LandingPage/Header/Header";

export default class Privacy extends Component {
  render() {
    return (
      <div className="privacy-container">
        <Header />
        <h1>Privacy Policy:</h1>
        <p>
          Hello! Welcome to Cup O’ Sugar, Inc. (“we” “us” “our” or “Cup O’
          Sugar”).
        </p>
        <p>This is our privacy policy.</p>
        <p>
          Cup O’ Sugar is committed to protecting your privacy. This Privacy
          Policy applies to the Cup O’ Sugar Site, Apps, Content, APIs, and data
          feeds (collectively the “Services”) and governs data collection and
          usage. By using the Services, you consent to the data practices
          described in this statement.
        </p>
        <p>
          By submitting personally identifiable information (“PII”) through our
          Services, you agree to the terms of this Privacy Policy and you
          expressly consent to the processing of your PII in accordance with our
          Privacy Policy.
        </p>
        <p>COLLECTION AND USE OF YOUR INFORMATION</p>
        <p>
          Activity and log data. We automatically store information related to
          your use of the Services, such as the pages you view on the Site, your
          browser type, IP address, requested URL, referring URL, and the date
          and time of your visit. We also log the products you scan, view, and
          other actions you perform while using the Services. We use this type
          of information to administer the Services and provide the highest
          possible level of service to you. We also use this information in the
          aggregate to perform statistical analyses of user behavior and
          characteristics in order to measure interest in and use of the various
          areas of the Services.
        </p>
        <p>
          Email. If you register to the Services or contact us via e-mail, we
          will collect your name and e-mail address, as well as any other
          content included in the e-mail, in order to send you a reply. When you
          post messages or comments on the bulletin board, chat room, blog or
          forum of our Services, the information contained in your posting will
          be stored on our service provider’s servers.
        </p>
        <p>
          Collection by Third Parties. If you post content (“Public Content”)
          for public view on the Services, we may distribute such Public Content
          to a wider audience by sharing it (or portions of it) with third
          parties so that they can publish it on their own websites and media
          platforms. We may ask them to credit you as the source of these
          contributions by including your account name and profile photo. We
          allow you to access third party services, such as Facebook and
          Twitter, to share your selected Public Content with those services.
          You can always opt out in your Cup O’ Sugar account settings.
        </p>
        <p>
          Third party advertising. Third parties serve some of the ads across
          our Services. We do not send any individualized personal information
          to them, but they may have access to information that they obtain
          through cookies or that you share with them yourself. Note that we do
          not rent, share, sell or trade PII with third parties for their direct
          marketing purposes.
        </p>
        <p>
          The content posted by these third parties will be reasonably
          identifiable as coming from a third party. We do not provide any PII
          to these advertisers, third-party websites, or other businesses. These
          third-party websites, businesses, and advertisers, or advertising
          companies working on their behalf, sometimes use tracking technology
          to deliver (or “serve”) the advertisements that appear on our Services
          directly to your browser or app. They automatically receive your IP
          address when this happens. They may also use cookies, JavaScript, web
          beacons (also known as action tags or single-pixel gifs), and other
          technologies to measure the effectiveness of their ads and to
          personalize or optimize advertising content. We do not have access to
          or control over cookies or other technologies that they may use, and
          the information practices of these advertisers and third-party
          websites or businesses are not covered by this Policy but are covered
          by their respective privacy policies. Some, but not all, third party
          advertising companies provide a mechanism to opt-out of their
          technology.
        </p>
        <p>
          Cookies. A cookie is a small text file that is stored on a user’s
          computer for record-keeping purposes such as site visitation. We send
          cookies to your computer in order to uniquely identify your browser
          and improve the quality of our service. We may use both session
          cookies (which expire once you close your browser) and persistent
          cookies (which stay on your computer until you delete them).
          Persistent cookies can be removed by following your browser help file
          directions. If you choose to disable cookies, some areas of the Site
          may not work properly or at all. Our cookies are linked to your
          information, such as your nickname, email address and password. We
          enable some of our business partners to use cookies in conjunction
          with your use of the Site (for example Google Analytics). We have no
          access to or control over the use of these cookies. These cookies
          collect information about your use of the Site, such as which web site
          you came from, which pages you visited within the Site, and possibly
          other sites you visit if those sites cooperate with the same third
          party, but do not collect your name, email address, contact
          information or other personally identifiable information that by
          itself would allow the third party to identify or contact you.
        </p>
        <p>
          Pixel Tags. In our emails to you, we may use “pixel tags”, commonly
          referred to as web beacons to determine if your email software or
          service can display html-formatted email (this helps us optimize the
          size of our email messages and conserve bandwidth).
        </p>
        <p>
          Feedback. You should feel free to give us feedback, register a
          complaint, or ask questions about the Services. We may store your
          communications, including any personal information you include in
          them, so that we can effectively respond to you.
        </p>
        <p>
          Administration. We may use the information described above for routine
          administrative purposes, such as investigating abuses on the Site,
          responding to user inquiries and enforcing and applying our Terms of
          Service and Statement.
        </p>
        <p>ADDITIONAL MATTERS</p>
        <p>
          Aggregate Information (non-personally identifiable). We share
          aggregated demographic and usage information about users of the
          Services with our business partners, such as food manufacturers, and
          retail stores. This information does not identify individual users. We
          do not link aggregate user data with PII.
          <br />
          Legal Disclaimer. We reserve the right to disclose your PII as
          required by law and when we believe that disclosure is necessary to
          protect our rights (or those of our Services users) and/or to comply
          with a judicial proceeding, court order, or legal process served on
          our Services.
        </p>
        <p>
          Affiliates. Although we currently do not have a parent company, any
          subsidiaries, joint ventures, or other companies under a common
          control (collectively, “Affiliates”), we may in the future. If another
          company acquires our company or our assets, that company will possess
          the PII collected by it and us and will assume the rights and
          obligations regarding your PII as described in this Privacy Policy.
          <br />
          Disclosure to Third Party Service Providers. We may share your PII
          with our third party service providers to provide you with the
          Services. Except as otherwise stated in this Privacy Policy, these
          third party service providers are required not to use your PII other
          than to provide the services requested by us. You expressly consent to
          the sharing of your PII with our service providers for the sole
          purpose of providing services to you.
        </p>
        <p>
          Marketing. We do not share your PII with third parties for promotional
          purposes. Links To Other Websites. If you click on a link to a third
          party site, you will leave the Services and go to the site you
          selected. Because we cannot control the activities of third parties,
          we cannot accept responsibility for any use of your PII by such third
          parties, and we cannot guarantee that they will adhere to the same
          privacy practices as Cup O’ Sugar. We encourage you to review the
          Privacy Policies of any other service provider from whom you request
          services.
          <br />
          Bulletin Boards/Chat Rooms/Blogs/Forums. If you use a bulletin board,
          chat room, blog or forum on the Services, you should be aware that any
          PII you submit there can be read, collected, or used by other users of
          these forums, and could be used to send you unsolicited messages. We
          are not responsible for the PII you choose to submit in these forums.
        </p>
        <p>
          Social Media (Features) and Widgets. Our Services includes Social
          Media Features (“Social Media Features”), such as the Facebook Like
          button and the Pinterest Pin button. The Social Media Features may
          collect your IP address, which page you are visiting on our Site and
          Services, and may set a cookie to enable the Social Media Features to
          function properly. Social Media Features are either hosted by a third
          party or hosted directly on our Site. Your interactions with these
          Features are governed by the privacy policy of the company providing
          it.
        </p>
        <p>COMMUNICATIONS FROM THE SITE</p>
        <p>
          Service-related Announcements. We will send you strictly
          service-related announcements on rare occasions when it is necessary
          to do so. For instance, if our service is temporarily suspended for
          maintenance, we might send you an email.
        </p>
        <p>
          Customer Service. Based upon the personally identifiable information
          you provide us, we will send you a welcoming email to verify your
          username and password. We will also communicate with you in response
          to your inquiries, to provide the services you request, and to manage
          your account.
          <br />
          Updating Personally Identifiable Information. If your personally
          identifiable information changes, you may update it by making the
          changes in the Cup O’ Sugar Services Settings screen. If you wish to
          delete your account please email us at contact@cuposugarapp.com. We
          will respond to your request to access within 30 days.
        </p>
        <p>DATA RETENTION</p>
        <p>
          We will retain your information for as long as your account is active
          or as needed to provide you services. If you wish to cancel your
          account or request that we no longer use your information to provide
          you services contact us at contact@cuposugarapp.com. We will retain
          and use your information as necessary to comply with our legal
          obligations, resolve disputes, and enforce our agreements.
        </p>
        <p>SECURITY</p>
        <p>
          The security of your PII is important to us. We follow generally
          accepted industry standards to protect the personally identifiable
          information submitted to us, both during transmission and once we
          receive it. No method of transmission over the Internet, or method of
          electronic storage, is perfectly secure, however. Therefore, while we
          strive to use commercially acceptable means to protect your PII, we
          cannot guarantee its absolute security.
        </p>
        <p>CHANGES IN THIS PRIVACY POLICY</p>
        <p>
          If we decide to change our privacy practices, we will post those
          changes to this Privacy Policy, the home page our Site, and other
          places we deem appropriate so that you are aware of what information
          we collect, how we use it, and under what circumstances, if any, we
          disclose it. We reserve the right to modify this Privacy Policy at any
          time, so please review it frequently. If we change how we use your
          personally identifiable information, we will notify you here, by
          email, or by means of a notice on our home page.
        </p>
        <p>QUESTIONS</p>
        <p>
          Any questions about this Privacy Policy should be addressed to
          contact@cuposugarapp.com.
        </p>
      </div>
    );
  }
}
